// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1iUNd","amount":"Amount_amount__3eZnd","tip":"Amount_tip__3D7mr","tipHeader":"Amount_tipHeader__x-AIO","tipsWrap":"Amount_tipsWrap__1azrE"};